import { MenuT } from 'types/frontend/Menu';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const messageMenuRootPath = '/teacherSide/message';

const messageMenu: MenuT = [
  {
    title: t('메시지'),
    items: [
      {
        title: t('메시지 보내기'),
        path: `${messageMenuRootPath}/send`,
      },
      {
        title: t('발신 기록'),
        path: `${messageMenuRootPath}/history`,
      },
    ],
  },
];

export { messageMenu };
